module.exports = __webpack_public_path__ + "img/approve-list11.296fb579.png";